module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-300italic.woff?793b1237017aeacd646fb80911425566";